__webpack_require__.p = "https://cdn.websky.aero/I8/static/";